// src/components/common/LoginSourceBadge.js

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDesktop } from "@fortawesome/free-solid-svg-icons";
import { faAndroid, faApple } from "@fortawesome/free-brands-svg-icons";

const SOURCE_MAP = {
  1: { icon: faDesktop, label: "Web",     color: "#0d6efd" },
  2: { icon: faAndroid, label: "Android", color: "#3ddc84" },
  3: { icon: faApple,   label: "iOS",     color: "#555555" },
};

const LoginSourceBadge = ({ login_source }) => {
  const config = SOURCE_MAP[login_source] ?? { icon: faDesktop, label: "Unknown", color: "#6c757d" };
  return (
    <span className="d-inline-flex align-items-center gap-1">
      <FontAwesomeIcon icon={config.icon} style={{ color: config.color }} />
      <span>{config.label}</span>
    </span>
  );
};

export default LoginSourceBadge;